import { render, staticRenderFns } from "./info-save.vue?vue&type=template&id=1e277128"
import script from "./info-save.vue?vue&type=script&lang=js"
export * from "./info-save.vue?vue&type=script&lang=js"
import style0 from "./info-save.vue?vue&type=style&index=0&id=1e277128&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports